module.exports = __webpack_public_path__ + "img/006-werewolf.bb1117a9.png";